import { LOGIN_USER_DETAIL_UPDATE, LOGOUT_USER_DETAIL } from "../types/user";

const initialState = {
  item: {},
};
const user = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER_DETAIL_UPDATE:
     return {
      ...state,
      item: { ...state.item, ...action.userdata.data }
      };
    case LOGOUT_USER_DETAIL:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
export default user;
